import * as React from 'react';
import '../css/action-buttons.sass';
import CampfireButton from './CampfireButton';
import Anchor from './Anchor';

export interface ActionButton {
  type?: 'primary' | 'secondary';
  label: string;
  onClick?: Function;
  sendTo?: string;
  name?: string;
  id?: string;
  style?: string;
  focus?: boolean;
  onKeyDown?: Function;
  disabled?: boolean;
  smol?: boolean;
  tel?: string;
  newWindow?: boolean;
  theme?: 'night' | 'day';
  color?: 'water' | 'blaze' | 'marshmallow' | 'coal';
  title?: string;
}

interface ActionButtonsProps {
  buttons: ActionButton[];
}

interface ActionButtonOrAnchorProps {
  id: string;
  btn: ActionButton;
}

export default function ActionButtons(props: ActionButtonsProps) {
  const primaryButtons = props.buttons.filter(
    (btn: ActionButton) => btn.type === 'primary'
  );
  const secondaryButtons = props.buttons.filter(
    (btn: ActionButton) => btn.type !== 'primary'
  );
  let keyIndex = 0;

  const ActionButtonOrAnchor = ({ id, btn }: ActionButtonOrAnchorProps) => {
    const { color = 'water', type = 'secondary', newWindow = false } = btn;
    return !btn.sendTo ? (
      <CampfireButton
        name="button"
        id={id}
        label={btn.label}
        color={color}
        frosty={!type || type === 'secondary'}
        ghost={!type || type === 'secondary'}
        onClick={(e: any) => {
          if (btn.onClick !== undefined) {
            btn.onClick(e);
          }
        }}
        style={btn.style}
        focus={btn.focus}
        onKeyDown={btn.onKeyDown}
        disabled={btn.disabled}
        smol={btn.smol}
        tel={btn.tel}
        newWindow={newWindow}
        theme={btn.theme}
        title={btn.title}
      />
    ) : (
      <Anchor
        id={id}
        href={btn.sendTo}
        displayAs='button'
        color={color}
        arialabel={btn.label}
        target={newWindow ? '_blank' : '_self'}
        focus={btn.focus}
        style={btn.style}
        theme={btn.theme}
        type={type}
        smol={btn.smol}
        disabled={btn.disabled}
      >
        {btn.label}
      </Anchor>
    );
  };
  return (
    <>
      <div className="groupButtons">
        {secondaryButtons &&
          secondaryButtons.map((btn: ActionButton, index: number) => {
            keyIndex += 1;
            return (
              <ActionButtonOrAnchor
                id={`secondaryButton-${index + 1}`}
                key={`${btn.label.toLowerCase().replace(' ', '')}${keyIndex}`}
                btn={btn}
              />
            );
          })}
        {primaryButtons &&
          primaryButtons.map((btn: ActionButton, index: number) => {
            keyIndex += 1;

            return (
              <ActionButtonOrAnchor
                id={`primaryButton-${index + 1}`}
                key={`${btn.label.toUpperCase().replace(' ', '')}${keyIndex}`}
                btn={btn}
              />
            );
          })}
      </div>
    </>
  );
}
